"use client";
import AppErrorBoundary from "@/shared/components/AppErrorBoundary";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (
      process.env.NEXT_PUBLIC_ENABLE_SENTRY !== "true" ||
      !process.env.NEXT_PUBLIC_SENTRY_DSN
    ) {
      return;
    }

    void import("@sentry/nextjs").then((Sentry) => {
      Sentry.captureException(error);
    });
  }, [error]);

  return (
    <html lang="fa" dir="rtl">
      <body>
        <AppErrorBoundary error={error} reset={reset} />
      </body>
    </html>
  );
}
